/**
 * Message éphémère de confirmation.
 *
 * Un craft qui ne se porte pas — une clé, un alliage — n'ouvre plus l'écran de
 * jet : il entre directement en réserve. Sans un mot, l'action paraissait sans
 * effet, d'autant que les compteurs d'ingrédients sont plafonnés à la quantité
 * requise et ne bougent donc pas quand on en a plus qu'il n'en faut.
 *
 * Purement d'affichage : rien n'est conservé, rien ne passe par l'état.
 */
const DUREE_MS = 2600

export function toast(texte: string) {
  const zone = document.querySelector("#toasts") ?? (() => {
    const d = document.createElement("div")
    d.id = "toasts"
    document.body.appendChild(d)
    return d
  })()
  const t = document.createElement("div")
  t.className = "toast"
  t.textContent = texte
  zone.appendChild(t)
  setTimeout(() => {
    t.classList.add("part")
    setTimeout(() => t.remove(), 300)
  }, DUREE_MS)
}
